/**
 * Custom commons static methods here
 */

import { Slider } from './models/Slider';
import { Feature } from './models/Feature';
import { environment } from '../../environments/environment';

export class CustomCommons {

    static readonly PATH_NAME = 'pathname'
    static readonly SCROLLABLE_PLANS = 'plans_section'

    static readonly MAIN_IMAGE = {
      image: './assets/images/main_image.webp',
      text: 'ACA VA TU SLOGAN',
      subText: 'Breve descripción de la empresa',
      btnLabel: 'Ir a contacto',
      btnLink:'/contact'
    }

    static readonly DUMMY_SLIDERS: Slider[] = [
    {
      id: -1,
      background: 'assets/images/slideshow1-1.webp',
      title: 'Sitios web sin complicaciones',
      text_part_1: 'Tu empresa',
      text_part_2: 'en internet'
    },
    {
      id: -2,
      background: 'assets/images/slideshow1-2.webp',
      title: 'Solo elige un plan y nosotros hacemos lo demás',
      text_part_1: 'Sin ',
      text_part_2: 'Configuraciones técnicas'
    },
    {
      id: -3,
      background: 'assets/images/slideshow1-3.webp',
      title: 'Tres planes: Premium, Medio y Básico',
      text_part_1: 'Elige el que mejor ',
      text_part_2: 'Se adapte a Ti!'
    },
    {
      id: -4,
      background: 'assets/images/slideshow1-4.webp',
      title: 'SEO dinámico y opiniones visibles en Google Maps (desde el Plan Medio)',
      text_part_1: 'Más visibilidad con ',
      text_part_2: 'SEO y opiniones'
    },
    {
      id: -5,
      background: 'assets/images/slideshow1-5.webp',
      title: 'Administra clientes, publicaciones y presupuestos desde tu panel',
      text_part_1: 'Controla ',
      text_part_2: 'Todo desde un solo lugar'
    }
  ]

  static readonly DUMMY_FEATURES: Feature[] = [
    {
      id: -1,
      image: 'assets/images/categories/cat-1.jpg',
      title: 'Sitio web instantáneo',
      text: 'Solo elige tu plan. Nosotros nos encargamos del resto. Tu sitio web listo sin configuraciones complicadas.',
      route: null,
      routelabel: null,
    },
    {
      id: -2,
      image: 'assets/images/categories/cat-2.jpg',
      title: 'Planes adaptables a tu negocio',
      text: 'Tres niveles: Básico, Medio y Premium. Elige el que mejor se ajuste a tus necesidades.',
      route: '',
      routelabel: null,
    },
    {
      id: -3,
      image: 'assets/images/categories/cat-3.jpg',
      title: 'Publicaciones personalizables',
      text: 'Administra tus publicaciones y mantenlas siempre actualizadas desde un panel simple y amigable.',
      route: '',
      routelabel: null,
    },
    {
      id: -4,
      image: 'assets/images/categories/cat-4.jpg',
      title: 'Gestión de clientes',
      text: 'Controla fácilmente tus clientes, presupuestos y respuestas desde un solo lugar.',
      route: '',
      routelabel: null,
    }
    ,
    {
      id: -5,
      image: 'assets/images/categories/cat-5.jpg',
      title: 'SEO automático por publicación',
      text: 'Cada publicación se optimiza automáticamente para destacar en Google según su contenido y ubicación.',
      route: '',
      routelabel: null,
    }
    ,
    {
      id: -6,
      image: 'assets/images/categories/cat-6.jpg',
      title: 'Opiniones visibles en tu web',
      text: 'Desde el Plan Medio, muestra las opiniones de tus clientes en Google Maps directamente en tu sitio.',
      route: '',
      routelabel: null,
    }
  ]

  static readonly DUMMY_PUBLIC_SERVICE = {
    id: -1,
    title: 'Características del servicio',
    content: 'Publinex es una solución desarrollada por Softdirex para dar visibilidad inmediata a tu empresa en internet.Olvídate de configurar puertos o direcciones web: solo elige el plan que se adapta a ti y nosotros creamos tu sitio automáticamente.Desde el plan más básico, puedes tener tu dominio propio, cargar dinámicamente los datos de tu organización y empezar a publicar contenido en categorías como Tecnología, Educación, Ciencias, entre otras.Además, Publinex optimiza cada publicación con etiquetas SEO para mejorar tu posicionamiento en buscadores.Nuestros planes son flexibles y están diseñados para ajustarse a las necesidades reales de tu negocio.Haz crecer tu presencia digital, fácil, rápido y sin complicaciones.',
    link:'',
    image: ''
  }

  static readonly DUMMY_PUBLICATIONS = [
    {
      id: -1,
      type: null,
      background: 'assets/images/pub-categories.webp',
      title: 'Distintas categorías',
      introduction: 'Comparte contenidos de distintas categorias segun tu plan.',
      btnLink: ''
    },
    {
      id: -2,
      type: null,
      background: 'assets/images/pub-edit.webp',
      title: 'Gestiona tus publicaciones',
      introduction: 'Edita, actualiza y publica tu contenido cuando lo necesites.',
      btnLink: ''
    },
    {
      id: -3,
      type: null,
      background: 'assets/images/pub-news.webp',
      title: 'Comparte tus novedades',
      introduction: 'Informa a tus clientes sobre actualizaciones, noticias y promociones.',
      btnLink: ''
    }
  ]

  static readonly DUMMY_HOMELINK = {
    id: -1,
    background: '../../../../assets/images/counter.jpg',
    name: '',
    title: "Puedes encontrar más productos en Escritorio Empresas",
    text: '¡Apúrate! Registrate y conoce todas las características de nuestros productos. ¡Aprovecha ahora!',
    button_label: 'Store',
    access: environment.coreFrontendEndpoint,
  }
  
  /* BEGIN | CUSTOM FUNCTIONS */
  /* END | CUSTOM FUNCTIONS */
}
